import { AvoltaAlarmMapping } from "~/configs/alarms/avolta-alarm.config";
import {  AvoltaAlarmEnum } from "~/configs/alarms/avolta-alarm.model";

export function getAlarmFromValues(values: {[key: string]: string|number}): AvoltaAlarmEnum[] {

    const alarms = Object.entries(values)
        .map(([key, value]) => {
            const alarm = AvoltaAlarmMapping[key];
            return alarm && value ? alarm : null; 
        })
        .filter(a => a);

    return alarms;
}